/**
 * Indexation intelligente des genres pour Livrenpoche
 * Version Finale : Gestion des pluriels et recherche élargie
 */
(function() {
  window.GenreManager = {
    indexByName: {},
    
    init: function() {
      if (typeof window.menuBhData === 'undefined') return false;
      
      const keys = Object.keys(window.menuBhData);
      
      keys.forEach(key => {
        const entry = window.menuBhData[key];
        if (entry.title && entry.handle) {
          // On crée une clé normalisée (sans 's' final) pour l'index
          const cleanKey = this.normalize(entry.title);
          
          if (!this.indexByName[cleanKey]) {
             this.indexByName[cleanKey] = entry;
          }
        }
      });
      console.log("GenreManager prêt : " + keys.length + " entrées.");
      return true;
    },

    // Normalisation puissante : enlève accents, caractères spéciaux et 's' finaux
    normalize: function(str) {
      if (!str) return "";
      return str.toLowerCase()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // Enlève les accents
        .replace(/[^a-z0-9\s]/g, "") // Garde lettres, chiffres et espaces
        .split(" ")
        .filter(function(word) { return word.length > 0; })
        .map(function(word) { 
           // Enlève le 's' ou 'x' à la fin si le mot fait plus de 3 lettres
           if (word.length > 3 && (word.endsWith('s') || word.endsWith('x'))) {
             return word.slice(0, -1);
           }
           return word;
        })
        .join(""); // Colle tout pour comparer "comediemusicale"
    },

    findLink: function(tagName, typeProduit) {
      const cleanTag = this.normalize(tagName);
      
      // 1. Essai direct (Exact match normalisé)
      if (this.indexByName[cleanTag]) {
        return this.filterEntry(this.indexByName[cleanTag], typeProduit);
      }

      // 2. Recherche approximative (Inclusion)
      const keys = Object.keys(this.indexByName);
      // On cherche la clé la plus longue qui matche pour éviter les faux positifs (ex: "Pop" dans "Pop Rock")
      let bestMatch = null;
      let maxLen = 0;

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        
        // Si le tag contient la clé du menu (ex: "Comédie musicale" contient "comediemusicale")
        // Ou l'inverse
        if ((cleanTag.includes(key) || key.includes(cleanTag)) && key.length > 3) {
           const entry = this.indexByName[key];
           if (this.filterEntry(entry, typeProduit)) {
             if (key.length > maxLen) {
               maxLen = key.length;
               bestMatch = entry;
             }
           }
        }
      }
      return bestMatch;
    },

    filterEntry: function(entry, typeProduit) {
      if (!entry || !entry.handle) return null;
      // Pour les CD/DVD, on interdit les liens vers des livres/revues/BD
      if (typeProduit === 'CD' || typeProduit === 'DVD') {
        if (entry.handle.indexOf('livre') !== -1 || entry.handle.indexOf('revue') !== -1 || entry.handle.indexOf('bd-') !== -1) {
          return null;
        }
      }
      return entry;
    }
  };

  window.addEventListener('load', function() {
    setTimeout(function() { window.GenreManager.init(); }, 200);
  });
})();